document.addEventListener('DOMContentLoaded', function() {
    // Smooth slideToggle function 
    function slideToggle(element) {
      const isOpen = element.style.maxHeight && element.style.maxHeight !== '0px';
      
      if (isOpen) {
        // Close: animate to 0
        element.style.maxHeight = '0px';
        element.style.paddingTop = '0px';
        element.style.paddingBottom = '0px';
      } else {
        // Open: get natural height and set max-height to accommodate it
        element.style.maxHeight = 'none';
        element.style.paddingTop = '1.2rem';
        element.style.paddingBottom = '1.2rem';
        const height = element.scrollHeight;
        element.style.maxHeight = '0px';
        
        // Force reflow
        element.offsetHeight;
        
        // Set to actual height + some buffer for safety
        element.style.maxHeight = (height + 50) + 'px';
      }
    }
  
    // Initialize and handle accordion functionality
    const accordionBlocks = document.querySelectorAll('.accordion-block');
    
    accordionBlocks.forEach(block => {
      const title = block.querySelector('.accordion-title');
      const content = block.querySelector('.accordion-content');
      
      if (title && content) {
        // Initialize all accordions as closed
        content.style.maxHeight = '0px';
        content.style.overflow = 'hidden';
        content.style.paddingTop = '0px';
        content.style.paddingBottom = '0px';
        
        // Add click handler
        title.addEventListener('click', function() {
          const isCurrentlyOpen = block.getAttribute('aria-expanded') === 'true';
          
          // Close all other accordions
          accordionBlocks.forEach(otherBlock => {
            if (otherBlock !== block && otherBlock.getAttribute('aria-expanded') === 'true') {
              const otherContent = otherBlock.querySelector('.accordion-content');
              otherBlock.setAttribute('aria-expanded', 'false');
              slideToggle(otherContent);
            }
          });
          
          // Toggle current accordion
          if (isCurrentlyOpen) {
            block.setAttribute('aria-expanded', 'false');
            slideToggle(content);
          } else {
            block.setAttribute('aria-expanded', 'true');
            slideToggle(content);
          }
        });
        
        // Add keyboard support
        title.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            title.click();
          }
        });
        
        // Make title focusable
        title.setAttribute('tabindex', '0');
        title.setAttribute('role', 'button');
      }
    });
  });